// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link , withRouter} from 'react-router-dom';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

class SiteListItem extends Base {
  constructor(props, context) {
    super(props);
  }


  render() {
    const { site, sponsor, sponsors, study, studies, studyUsers } = this.props;
    const selectedSponsor = sponsor;
    const selectedStudy = study;

    // find study users count that applies to this site number
    const siteStudyUsers = studyUsers ? studyUsers.filter(studyUser => site.number == studyUser.siteNumber) : null;
    // console.log("SITE STUDY USERS", siteStudyUsers)

    return (
      <tr className="hoverable">
        <td className="_20"><Link to={`/admin/content-management/studies/${site._group}/sites/${site._id}`}>{site.name}</Link></td>
        <td className="_20">{site.number}</td>
        { siteStudyUsers ?
            <td className="_20">{siteStudyUsers.length}</td>
          :
            null
        }
        <td className="_20">{selectedSponsor ? selectedSponsor.name : ''}</td>
        <td className="_20">{selectedStudy ? selectedStudy.name : ''}</td>
      </tr>
    )
  }
}

SiteListItem.propTypes = {
  site: PropTypes.object.isRequired
  , sponsor: PropTypes.object // either single or array here
  , study: PropTypes.object
  , studyUsers: PropTypes.array // optional, display user count
}

export default withRouter(SiteListItem);



// WEBPACK FOOTER //
// modules/site/components/SiteListItem.js.jsx